/**
 * Reset app state - clears all sessionStorage except essential login/auth items
 * Also clears Redux state for documents, extractedData, etc.
 */
import { resetDocumentsState, setExtractedData, setStepsCompleted, clearValidationErrors, clearTaricJsonErrors, resetSelectedSender, resetSelectedReceiver, resetSelectedAgent } from '../store/reducers';

export const resetAppState = (dispatch) => {
  // Essential items to keep (login/auth related)
  const essentialKeys = ['token', 'refresh_token', 'email', 'expires', 'user_id'];
  
  // Get all essential values before clearing
  const essentialValues = {};
  essentialKeys.forEach(key => {
    const value = sessionStorage.getItem(key);
    if (value !== null) {
      essentialValues[key] = value;
    }
  });
  
  // Clear all sessionStorage
  sessionStorage.clear();
  
  // Restore essential values
  Object.keys(essentialValues).forEach(key => {
    sessionStorage.setItem(key, essentialValues[key]);
  });
  
  // Clear Redux state
  dispatch(resetDocumentsState());
  dispatch(setExtractedData(null));
  dispatch(setStepsCompleted(false));
  dispatch(clearValidationErrors());
  dispatch(clearTaricJsonErrors());
  dispatch(resetSelectedSender());
  dispatch(resetSelectedReceiver());
  dispatch(resetSelectedAgent());
  
  console.log('App state reset - all data cleared except login credentials');
};

